import { message } from 'antd';
import { Icon } from '../../icon/icon';
import { isLocked } from '../../../utils/messages/messageLock';

export const openMessageError = ({
  content,
  icon,
  iconColor,
  forced = false,
  ...props
}) => {
  // // 🚫 Nếu đang khóa thì không hiển thị message
  // if (isLocked() && !forced) return;

  message.open({
    content: <span className="text-title-medium">{content}</span>,
    icon: (
      <span
        className="w-24 h-24 flex"
        style={{ color: iconColor ?? '#E5654E' }}
      >
        {icon ?? <Icon.ICError />}
      </span>
    ),
    ...props,
  });
};
